import { Link } from "react-router-dom";
import type { Topic } from "@/types/content";
import SectionHeading from "@/components/feature/SectionHeading";

export default function CategoryGrid({ topics }: { topics: Topic[] }) {
  return (
    <section aria-labelledby="category-title" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="按主题逛"
          title="找到你想看的板块"
          description="从校园热点到食堂测评，八个常驻板块覆盖学生日常讨论的绝大部分场景，也可以直接在讨论区按学校筛选。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {topics.map((topic, index) => (
            <Link
              key={topic.slug}
              to={`/topics?category=${topic.slug}`}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <span
                className={`flex h-11 w-11 items-center justify-center rounded-lg ${
                  index % 3 === 0
                    ? "bg-primary-100 text-primary-700"
                    : index % 3 === 1
                      ? "bg-accent-100 text-accent-800"
                      : "bg-secondary-100 text-secondary-900"
                }`}
              >
                <i className={`${topic.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {topic.name}
              </h3>
              <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-600">
                {topic.description}
              </p>
              <span className="mt-4 flex items-center justify-between text-xs text-foreground-500">
                <span>{topic.postCount} 篇讨论</span>
                <span className="flex h-5 w-5 items-center justify-center text-foreground-400 transition-colors group-hover:text-primary-600">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}